import React from 'react';
import PropTypes from 'prop-types';
import ReviewCard from './ReviewCard';
import bellIcon from '../../../assets/images/bell-icon.svg';
import './ReviewIndexPage.scss';

const renderMultipleReviewCards = (reviews) => reviews.map(
  (review) => (
    (
      <ReviewCard
        key={review.project_resource_id}
        resourceId={review.resource_id}
        projectResourceId={review.project_resource_id}
        name={review.consultant_name}
        projectName={review.project_name}
        reviewed={review.resource_id !== null}
        rate={review.hourly_rate}
      />
    )
  ),
);

function ReviewIndexPage({ reviews }) {
  return (
    <div className="style-guide dashboard-body-background">
      <div className="multi-review-container">
        <div className="header">
          <h2>
            <img src={bellIcon} alt="review-alert-icon" />
            {reviews.length}
            {' '}
            Pending Consultant Review(s)
          </h2>
          <p>
            Leave feedback on your experience working with these consultants.
          </p>
          <p>
            You&apos;ll be able to give private feedback, just for Clora, and a public review to
            help future hiring managers.
          </p>
        </div>
        <div className="cards mb-3">
          {renderMultipleReviewCards(reviews)}
        </div>
      </div>
    </div>
  );
}

ReviewIndexPage.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ReviewIndexPage;
